import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ThemeProvider } from '@/components/theme-provider'
import { AuthProvider } from '@/contexts/AuthContext'
import { OnboardingProvider } from '@/contexts/OnboardingContext'
import { SearchProvider } from '@/contexts/SearchContext'
import { MobileMenuProvider } from '@/contexts/MobileMenuContext'
import { router } from '@/router'
import { initializeStorage } from '@/services'
import './index.css'

initializeStorage()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="axioma-ui-theme">
      <AuthProvider>
        <OnboardingProvider>
          <SearchProvider>
            <MobileMenuProvider>
              <RouterProvider router={router} />
              <Toaster position="top-right" richColors />
            </MobileMenuProvider>
          </SearchProvider>
        </OnboardingProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
)
